export default "__VITE_ASSET__DP1Z8cqm__"